import { MdOutlineDelete, MdOutlineEdit } from 'react-icons/md'
import { Link } from 'react-router-dom'
import TractJoinList from './TractJoinList'

const TractsTable = ({
    tracts,
    setEditTract,
    showHideAdd,
    markedDocuments,
    setMarkedDocuments,
    setTractToDelete,
}) => {
    
    return (
        
        <table>
            <thead>
                <tr className="sticky top-0 bg-base-100">
                    <th>
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                className="checkbox-tract"
                                checked={tracts.length && markedDocuments.length === tracts.length}
                                onChange={e => {
                                    if (e.target.checked)
                                        setMarkedDocuments(tracts.map(tract => tract.id) || [])
                                    else
                                        setMarkedDocuments([])
                                }} />
                        </div>
                    </th>
                    <th>Tract Name</th>
                    <th>Runsheet</th>
                    <th>Gross Acreage</th>
                    {/* <th>Assigned To</th> */}
                    {/* <th>Status</th> */}
                    {/* <th>Status Date</th> */}
                    {/* <th>Cert. Date</th> */}
                    <th>County</th>
                    <th>Section</th>
                    <th>Block</th>
                    <th>Lot</th>
                    <th></th>
                </tr>
            </thead>
            <tbody className="list">
                {tracts.map((tract, i) => (
                    <tr key={i}>
                        <td className="relative">
                            <div className="flex items-center">
                                <input
                                    type="checkbox"
                                    className={'checkbox-tract'}
                                    checked={markedDocuments.includes(tract.id)}
                                    onChange={e => {
                                        if (e.target.checked) {
                                            setMarkedDocuments(prevMarked => [...prevMarked, tract.id])
                                        } else {
                                            setMarkedDocuments(prevMarked => prevMarked.filter(id => id !== tract.id))
                                        }
                                    }} />
                            </div>
                        </td>
                        <td>
                            <Link
                                to={`/tract/${tract.id}/ownership`}>
                                {tract.name}
                            </Link>
                        </td>
                        <td>
                            <TractJoinList tract={tract} />
                        </td>
                        <td>{tract.grossAcreage}</td>
                        {/* <td>{tract.assignedUser?.firstName ?? ''}</td>
                        <td>{tract.status}</td>
                        <td>{dayjs(tract.statusDate).format('MM/DD/YYYY')}</td>
                        <td>{dayjs(tract.certDate).format('MM/DD/YYYY')}</td> */}
                        <td>
                            <div className="flex flex-col gap-2">
                                <span>{tract.county?.name} - {tract.county?.state.name}</span>
                                {tract.township && <span>Township: {tract.township?.name}</span>}
                                {tract.range && <span>Range: {tract.range?.name}</span>}
                                {tract.survey && <span>Survey: {tract.survey?.name}</span>}
                            </div>
                        </td>
                        <td>
                            {[tract.section1, tract.section2, tract.section3, tract.section4]
                                .filter(s => !!s).join(', ')}
                        </td>
                        <td>{tract.block}</td>
                        <td>{tract.lot}</td>
                        <td>
                            <div className="flex gap-2">
                                <MdOutlineEdit
                                    data-tooltip-id="default-tip"
                                    data-tooltip-content="Edit"
                                    className="text-lg cursor-pointer"
                                    onClick={() => {
                                        setEditTract(tract)
                                        showHideAdd(true)
                                    }}
                                    data-test-id="TractsTableRowEditButton" />
                                <MdOutlineDelete
                                    data-tooltip-id="default-tip"
                                    data-tooltip-content="Delete"
                                    className="text-lg cursor-pointer"
                                    onClick={() => {
                                        setTractToDelete(tract)
                                    }}
                                    data-test-id="TractsTableRowDeleteButton" />
                                {/* <MdOutlineAssignmentInd
                                    className="text-lg cursor-pointer"
                                    data-tooltip-id="default-tip"
                                    data-tooltip-content="Assign"
                                    onClick={() => {
                                        setEditTract(tract)
                                        setAssignedTracts([tract])
                                        handleShowHideAssignToUser(!showAssignToUser)
                                    }} /> */}
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
        
    )
    
}

export default TractsTable
